const NAME = 'sidebar';

export { NAME };

export const INDEX_NONE = -1;
export const INDEX_SEARCH = 0;
export const INDEX_CATALOG = 1;
export const INDEX_INTERVIEW = 2;
export const INDEX_REGISTRY_ENTRIES = 3;
export const INDEX_MAP = 4;
export const INDEX_WORKBOOK = 5;
export const INDEX_INDEXING = 6;
export const INDEX_ADMINISTRATION = 7;
export const INDEX_PROJECT_ACCESS = 8;
export const INDEX_PROJECTS = 9;
export const INDEX_INSTITUTIONS = 10;
export const INDEX_HELP_TEXTS = 11;
